<template>
  <button class="btn" :class="btnClass" @click.prevent="follow">
    <!-- <fa-icon :icon="['fal', icon]"/> -->
    <span class="hidden-xs">{{followWord}}</span></button>
</template>

<script>
    export default {
        props:['blog'],
        computed: {
            isFollowing() {
              return this.$store.getters['user/follows'].includes(this.blog._id)
            },
            followWord(){
                return this.isFollowing ? 'unfollow' : 'follow';
            },
            btnClass() {
              return this.isFollowing ? 'btn-primary' : 'btn-outline-primary';
            },
            icon() {
              return this.isFollowing ? 'user-minus' : 'user-plus';
            }
        },
        created() {
        },
        methods: {
            follow(){
                if(this.$store.getters['user/isLoggedIn']){
                    this.$store.dispatch('user/followBlog', this.blog.url)
                } else {
                    this.$router.push({name:'Registration'});
                }
            }
        }
    }
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/components/ui/buttons/FollowButton.vue